const initialState = {
  userGroupList: [],
  group: [],
  totalGroupRecord: 0,
};

const groupManagement = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_USER_GROUP_LIST": {
      const userGroupList = action.payload.rows;
      const totalGroupRecord = action.payload.count;
      return { ...state, userGroupList, totalGroupRecord };
    }
    case "FETCH_USER_GROUP_LIST_BY_ID": {
      return { ...state, group: action.payload };
    }
    case "CREATE_USER_GROUP": {
      const newGroup = action.payload;
      return {
        ...state,
        totalGroupRecord: state.totalGroupRecord + 1,
        userGroupList: state.userGroupList
          .concat(newGroup)
          .slice()
          .sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
          }),
      };
    }
    case "EDIT_USER_GROUP": {
      let groupsWithoutEdited = state.userGroupList.filter(
        (g) => g.id !== action.payload.id
      );
      return {
        ...state,
        userGroupList: [...groupsWithoutEdited, action.payload]
          .slice()
          .sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
          }),
      };
    }
    case "DELETE_USER_GROUP": {
      var deletedList = state.userGroupList.filter(
        (x) => !action.payload.includes(x.id)
      );
      return {
        ...state,
        totalGroupRecord: state.totalGroupRecord - 1,
        userGroupList: deletedList,
      };
    }
    default:
      return state;
  }
};

export default groupManagement;
